import template from "./quote-template-name-form.html";

const QuoteTemplateNameFormComponent = {
  bindings: {
    name: "<",
    onSave: "&",
  },
  template: template,
  controller: class QuoteTemplateNameFormController {
    save() {
      if (this.form.$valid) this.onSave({ name: this.name });
    }
  },
};

export default QuoteTemplateNameFormComponent;
